export class ActionBlock {
    constructor(blockName, actions = []) {
        actions.map(action => this[action] = `${blockName}__${action}` )
    }
}

export const APP = new ActionBlock('FILTERS', ['SET_FIELD', 'SET_THEME', 'RESET_DATA']);
export const COUNTRIES = new ActionBlock('COUNTRIES', ['SET_DATA', 'SET_CURRENT', 'SET_FIELD']);
